(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faine-instagram-feed"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  if (customElements.get('faine-instagram-feed')) return;

  class FaineInstagramFeed extends HTMLElement {
    connectedCallback() {
      var sectionId = this.dataset.sectionId;

      // Read post data from the JSON script tag — no Liquid needed here
      var dataEl = document.getElementById('ig-posts-data-' + sectionId);
      var posts  = dataEl ? JSON.parse(dataEl.textContent || '[]') : [];

      if (!posts.length) return;

      var modal       = this.querySelector('.faine-ig-modal');
      var modalImg    = this.querySelector('.ig-modal__img');
      var modalCap    = this.querySelector('.ig-modal__caption');
      var modalHash   = this.querySelector('.ig-modal__hashtags');
      var modalDate   = this.querySelector('.ig-modal__date');
      var modalFollow = this.querySelector('.ig-modal__follow');
      var backdrop    = this.querySelector('.ig-modal__backdrop');
      var closeBtn    = this.querySelector('.ig-modal__close');
      var prevBtn     = this.querySelector('.ig-modal__nav--prev');
      var nextBtn     = this.querySelector('.ig-modal__nav--next');
      var grid        = this.querySelector('.ig-grid');
      var currentIdx  = 0;
      var self        = this;

      function openModal(idx) {
        currentIdx = idx;
        renderModal();
        modal.removeAttribute('hidden');
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        closeBtn.focus();
      }

      function closeModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('hidden', '');
        document.body.style.overflow = '';
      }

      function renderModal() {
        var p = posts[currentIdx];
        if (!p) return;
        modalImg.src    = p.src;
        modalImg.srcset = p.srcset;
        modalImg.alt    = p.alt;
        modalCap.textContent  = p.caption;
        modalHash.textContent = p.hashtags;
        modalDate.textContent = p.date;
        if (p.url) modalFollow.href = p.url;
        prevBtn.style.display = posts.length <= 1 ? 'none' : '';
        nextBtn.style.display = posts.length <= 1 ? 'none' : '';
      }

      function goNext() { currentIdx = (currentIdx + 1) % posts.length; renderModal(); }
      function goPrev() { currentIdx = (currentIdx - 1 + posts.length) % posts.length; renderModal(); }

      if (grid) {
        grid.addEventListener('click', function(e) {
          var post = e.target.closest('.ig-post');
          if (!post || post.classList.contains('ig-post--placeholder')) return;
          openModal(parseInt(post.dataset.index, 10));
        });
        grid.addEventListener('keydown', function(e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          var post = e.target.closest('.ig-post');
          if (!post) return;
          e.preventDefault();
          openModal(parseInt(post.dataset.index, 10));
        });
      }

      backdrop.addEventListener('click', closeModal);
      closeBtn.addEventListener('click', closeModal);
      nextBtn.addEventListener('click', goNext);
      prevBtn.addEventListener('click', goPrev);

      document.addEventListener('keydown', function(e) {
        if (!modal.classList.contains('is-open')) return;
        if (e.key === 'Escape')     closeModal();
        if (e.key === 'ArrowRight') goNext();
        if (e.key === 'ArrowLeft')  goPrev();
      });

      var touchStartX = 0;
      modal.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
      modal.addEventListener('touchend',   function(e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) { diff > 0 ? goNext() : goPrev(); }
      }, { passive: true });
    }
  }

  customElements.define('faine-instagram-feed', FaineInstagramFeed);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faine-promo-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-promo-code]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var code = btn.getAttribute('data-promo-code');
      var feedback = btn.querySelector('.promo-code-pill__feedback');

      navigator.clipboard.writeText(code).then(function () {
        if (feedback) {
          feedback.classList.add('is-visible');
          setTimeout(function () {
            feedback.classList.remove('is-visible');
          }, 2200);
        }
      }).catch(function () {
        // Fallback for browsers that block clipboard
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
        if (feedback) {
          feedback.classList.add('is-visible');
          setTimeout(function () { feedback.classList.remove('is-visible'); }, 2200);
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faine-tiktok-feed"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var sectionId = '{{ section.id }}';

  function init() {
    var dataEl = document.getElementById('tt-posts-data-' + sectionId);
    var posts  = dataEl ? JSON.parse(dataEl.textContent || '[]') : [];

    if (!posts.length) return;

    var modal      = document.getElementById('faine-tt-modal-' + sectionId);
    if (!modal) return;

    var modalImg   = document.getElementById('tt-modal-img-' + sectionId);
    var modalPlay  = document.getElementById('tt-modal-play-' + sectionId);
    var modalCap   = document.getElementById('tt-modal-caption-' + sectionId);
    var modalHash  = document.getElementById('tt-modal-hashtags-' + sectionId);
    var modalDate  = document.getElementById('tt-modal-date-' + sectionId);
    var modalWatch = document.getElementById('tt-modal-watch-' + sectionId);
    var statViews  = document.getElementById('tt-modal-stat-views-' + sectionId);
    var statLikes  = document.getElementById('tt-modal-stat-likes-' + sectionId);
    var viewsEl    = document.getElementById('tt-modal-views-' + sectionId);
    var likesEl    = document.getElementById('tt-modal-likes-' + sectionId);
    var backdrop   = modal.querySelector('.tt-modal__backdrop');
    var closeBtn   = modal.querySelector('.tt-modal__close');
    var prevBtn    = modal.querySelector('.tt-modal__nav--prev');
    var nextBtn    = modal.querySelector('.tt-modal__nav--next');
    var currentIdx = 0;
    var ttUrl      = '{{ tt_url }}';

    function openModal(idx) {
      currentIdx = idx;
      renderModal();
      modal.removeAttribute('hidden');
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    function renderModal() {
      var p = posts[currentIdx];
      if (!p) return;

      modalImg.src    = p.src;
      modalImg.srcset = p.srcset;
      modalImg.alt    = p.alt;
      modalCap.textContent  = p.caption;
      modalHash.textContent = p.hashtags;
      modalDate.textContent = p.date;

      var postUrl = p.url || ttUrl;
      if (modalWatch) modalWatch.href = postUrl;
      if (modalPlay)  modalPlay.href  = postUrl;

      if (viewsEl && statViews) {
        viewsEl.textContent = p.views;
        statViews.style.display = p.views ? '' : 'none';
      }
      if (likesEl && statLikes) {
        likesEl.textContent = p.likes;
        statLikes.style.display = p.likes ? '' : 'none';
      }

      prevBtn.style.display = posts.length <= 1 ? 'none' : '';
      nextBtn.style.display = posts.length <= 1 ? 'none' : '';
    }

    function goNext() { currentIdx = (currentIdx + 1) % posts.length; renderModal(); }
    function goPrev() { currentIdx = (currentIdx - 1 + posts.length) % posts.length; renderModal(); }

    var grid = document.getElementById('tt-grid-' + sectionId);
    if (grid) {
      grid.addEventListener('click', function(e) {
        var post = e.target.closest('.tt-post');
        if (!post || post.classList.contains('tt-post--placeholder')) return;
        openModal(parseInt(post.dataset.index, 10));
      });
      grid.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          var post = e.target.closest('.tt-post');
          if (!post) return;
          e.preventDefault();
          openModal(parseInt(post.dataset.index, 10));
        }
      });
    }

    backdrop.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);
    nextBtn.addEventListener('click', goNext);
    prevBtn.addEventListener('click', goPrev);

    document.addEventListener('keydown', function(e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape')     closeModal();
      if (e.key === 'ArrowRight') goNext();
      if (e.key === 'ArrowLeft')  goPrev();
    });

    var touchStartX = 0;
    modal.addEventListener('touchstart', function(e){ touchStartX = e.touches[0].clientX; }, { passive: true });
    modal.addEventListener('touchend', function(e){
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) { diff > 0 ? goNext() : goPrev(); }
    }, { passive: true });
  }

  init();

  // Re-initialize when the theme editor reloads this section
  document.addEventListener('shopify:section:load', function(e) {
    if (e.detail && e.detail.sectionId === sectionId) init();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
